import _pickBy from 'lodash/pickBy';

const createCommissionSanitizer = params => {
  const sanitizedParams = params;

  return _pickBy(sanitizedParams, param => !!param || param === false || param === 0 || param !== '--');
};

export default createCommissionSanitizer;
